import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

am4core.options.commercialLicense = true;

export { am4core };
export { am4charts };